import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 p-3 md:p-4 animate-in slide-in-from-bottom duration-300" data-id="element-287">
      <div className="container mx-auto max-w-5xl flex items-center justify-between gap-4" data-id="element-288">
        <div className="hidden md:block" data-id="element-289">
          <p className="font-bold text-gray-900" data-id="element-290">
            Cosmética Natural y Artesanal
          </p>
          <p className="text-xs text-[#4A6741] font-medium" data-id="element-291">
            Oferta especial: $6.36 USD
          </p>
        </div>
        <div className="flex-1 md:flex-none" data-id="element-292">
          <Button variant="urgent" size="md" fullWidth className="md:w-auto shadow-none" data-id="element-293">
            DESCARGAR AHORA
          </Button>
        </div>
      </div>
    </div>;
}